import { useCallback } from "react";
import { track } from "@visioni/a3s-analytics";
import { useRecordCameraActivity } from "@visioni/a3s-activity/app";
import type { ClipCompilationAccessMethod } from "@visioni/a3s-activity/client-messages";
import type { CompilationListItem } from "@visioni/a3s-media/app";
import { AssetCameraKey, SiteId } from "@visioni/a3s-schema";
import { cameraScope } from "@src/features/cameras/analytics";
import { ClipCompilationDownloaded, ClipCompilationWatched } from "../analytics";

/**
 * Records a `clip_compilation_viewed` audit entry for a compilation, saying
 * whether it was watched or downloaded, and the matching Amplitude event.
 */
export function useRecordCompilationViewed(): (item: CompilationListItem, via: ClipCompilationAccessMethod) => void {
  const recordActivity = useRecordCameraActivity();

  return useCallback(
    (item: CompilationListItem, via: ClipCompilationAccessMethod) => {
      recordActivity({
        siteId: SiteId.fromString(item.siteId),
        assetCameraKey: AssetCameraKey.fromString(item.cameraKey),
        body: { kind: "clip_compilation_viewed", requestId: item.id, via },
      });
      track(via === "download" ? ClipCompilationDownloaded : ClipCompilationWatched, {
        ...cameraScope(undefined, item.siteId, item.cameraKey),
        compilation_id: item.id,
      });
    },
    [recordActivity],
  );
}
